import { useMutation } from "react-query";
import { API } from "../../../utils/AxiosInstance";
import {
    GenerateOtpResponse,
    LoginOTPParams,
    SessionResponse,
    GenerateOTPProps,
} from "./types";

export const useGenerateOTPMutation = () =>
    useMutation(({ deliveryMode, email, client_id }: GenerateOTPProps) =>
        API.post<GenerateOtpResponse>("/sessions/generate_otp", {
            delivery_mode: deliveryMode,
            email,
            client_id,
        })
    );

export const useLoginWithOTPMutation = () =>
    useMutation((params: LoginOTPParams) =>
        API.post<SessionResponse>("/sessions", { ...params })
    );
